<template>
  <div>
    <avue-crud :table-loading="list.loading" :option="option" :data="list.data" ref="crud"
      @refresh-change="refreshChange">
      <!-- 自定义搜索框 -->
      <template slot="mySearch">
        <Search />
      </template>
      <!-- 自定义表格操作栏 -->
      <template #menu="{ row }">
        <el-button v-auth="'SECURITY_USER_DEVICE_EDIT'" type="text" size="small" @click="edit(row)">
          编辑
        </el-button>
        <el-button v-auth="'SECURITY_USER_DEVICE_DEL'" type="text" size="small" @click="del(row.id)">
          删除
        </el-button>
      </template>
    </avue-crud>
    <!-- 分页组件 -->
    <ElementPagination style="margin-bottom: 20px" :current-page="searchParams.current" :page-size="searchParams.size"
      :total="searchParams.total" :page-sizes="[10, 20, 30, 40, 50]" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :disabled="list.disabled" />
    <!-- 新增/编辑 对话框 -->
    <Add ref="add" />
  </div>

</template>

<script>
import Search from './search.vue'
import Add from './add.vue'
import { formatEditData } from '../utils/index'
import { deleteDevice } from '@/api/security/userDevice'
import Message from '@/components/Message'
import ElementPagination from "@/components/ElementPagination";
export default {
  name: 'WebSaaSTable',
  inject: ['searchParams', 'list', 'loadList'],
  components: {
    Search,
    Add,
    ElementPagination
  },

  data() {
    return {
      /** avue配置 */
      option: {
        lazy: true,
        tip: false,
        simplePage: true,
        searchShow: true,
        // searchMenuSpan: 6,
        tree: true,
        border: true,
        /** 表格索引 */
        index: false,
        /** 表格搜索显隐按钮 */
        searchShowBtn: true,
        /** 是否启用功能按钮 */
        searchIcon: true,
        searchIndex: 0,
        /** 表格查看按钮 */
        viewBtn: false,
        /** 表格新增按钮 */
        addBtn: false,
        /** 表格删除按钮 */
        delBtn: false,
        /** 表格修改按钮 */
        editBtn: false,
        /** 导出按钮 */
        excelBtn: false,
        /** 是否有选择框	 */
        selection: false,
        /** 表格高度 */
        // height: 500,
        /** 是否有操作栏 */
        menu: true,
        /** 操作栏宽度 */
        menuWidth: 120,
        // menuFixed: true,
        column: [
          {
            label: "ID",
            prop: "id"
          },
          {
            label: "命中val",
            prop: "hitVal"
          },
          {
            label: "公网音频封禁",
            prop: "cloudAudioFlag",
            width: '100',
            dicData: [
              { label: "否", value: "0" },
              { label: "是", value: "1" }
            ]
          },
          {
            label: "云桌面封禁",
            prop: "cloudDeskFlag",
            width: '100',
            dicData: [
              { label: "否", value: "0" },
              { label: "是", value: "1" }
            ]
          },
          {
            label: "公网镜像封禁",
            prop: "cloudMirrorFlag",
            width: '100',
            dicData: [
              { label: "否", value: "0" },
              { label: "是", value: "1" }
            ]
          },
          {
            label: "好友分享封禁",
            prop: "friendShareFlag",
            width: '100',
            dicData: [
              { label: "否", value: "0" },
              { label: "是", value: "1" }
            ]
          },
          {
            label: "公网图片封禁",
            prop: "cloudPicFlag",
            width: '100',
            dicData: [
              { label: "否", value: "0" },
              { label: "是", value: "1" }
            ]
          },
          {
            label: "公网视频封禁",
            prop: "cloudVideoFlag",
            width: '100',
            dicData: [
              { label: "否", value: "0" },
              { label: "是", value: "1" }
            ]
          },
          {
            label: "局域网音频封禁",
            prop: "lanAudioFlag",
            width: '120',
            dicData: [
              { label: "否", value: "0" },
              { label: "是", value: "1" }
            ]
          },
          {
            label: "局域网镜像封禁",
            prop: "lanMirrorFlag",
            width: '120',
            dicData: [
              { label: "否", value: "0" },
              { label: "是", value: "1" }
            ]
          },
          {
            label: "局域网图片封禁",
            prop: "lanPicFlag",
            width: '120',
            dicData: [
              { label: "否", value: "0" },
              { label: "是", value: "1" }
            ]
          },
          {
            label: "局域网视频封禁",
            prop: "lanVideoFlag",
            width: '120',
            dicData: [
              { label: "否", value: "0" },
              { label: "是", value: "1" }
            ]
          },
          {
            label: "类型",
            prop: "type",
            dicData: [
              { label: "用户", value: "1" },
              { label: "设备", value: "2" }
            ]
          },
          {
            label: "创建人",
            prop: "createBy"
          },
          {
            label: "创建时间",
            prop: "createTime"
          },
          {
            label: "备注",
            prop: "remark"
          },
          {
            label: "修改人",
            prop: "updateBy"
          },
          {
            label: "更新时间",
            prop: "updateTime"
          },
          {
            label: "",
            prop: "my",
            hide: true,
            showColumn: false,
            search: true,
            display: false,
            menuClassName: "myClass",
            searchslot: true,
          },
        ],
      },
    };
  },


  methods: {
    /** 编辑 */
    edit(row) {
      console.log("🚀 ~ edit ~ row:", row)
      this.$refs.add.show('edit', formatEditData(row));
    },
    /** 删除 */
    del(id) {
      this.$confirm('是否删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data } = await deleteDevice(id);
        if (data.code === 200) {
          Message.success('删除成功')
          this.loadList();
        }
      }).catch(() => {
        console.log("🚀 ~ del ~ 已取消删除")
      });

    },
    //^ ^--------------分页相关-------------^ ^
    /** avue的刷新 */
    refreshChange() {
      this.loadList();
    },
    /** 每页条数change */
    handleSizeChange(val) {
      this.searchParams.size = val;
      Message.success(`每页 ${val} 条`);
      /** 更新数据 */
      this.loadList();
    },
    /** 当前页change */
    handleCurrentChange(val) {
      this.searchParams.current = val;
      Message.success(`当前页 ${val}`);
      /** 更新数据 */
      this.loadList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../.././styles/avue-crud-normal.scss";
</style>
